<template>
    <div class="order-group">
        <div class="order-list">
            <div class="order-row-header" v-if="editabled === false">
                {{$t('user_center_order_order_num')}}：{{goods.order_sn}}
            </div>
            <div class="order-row">
                <div class="">
                    <Checkbox class="goods-checkbox" v-if="editabled" :label="goods.id" v-model="goods.isSelect">
                        <div class="goods-header">
                            <img src="../../../assets/profile/app_icon@2x.png" alt="">
                        </div>
                    </Checkbox>
                    <div class="goods-header" v-else>
                        <img src="../../../assets/profile/app_icon@2x.png" alt="">
                    </div>
                </div>

                <div class="goods-desc">
                    <h3>{{goods.goods_name}}</h3>
                    <p>{{goods.goodsDesc}}</p>
                </div>
                <div class="goods-price">{{goods.price}}</div>
                <div class="goods-num">
                    <div class="goods-num-editable" v-if="editabled">
                        <button type="button" class="minus" @click="minus">
                            <Icon type="minus" size="12"></Icon>
                        </button>
                        <span class="number">{{goods.num}}</span>
                        <button type="button" class="plus" @click="plus">
                            <Icon type="plus" size="12"></Icon>
                        </button>
                    </div>
                    <span v-if="editabled === false">{{goods.num}}</span>
                </div>
                <div class="goods-price text-primary">{{goods.price * goods.num}}</div>
                <div class="goods-operation">
                    <a href="javascript:;" v-if="operation === 'exchange'">{{$t('user_center_order_return_exchange')}}</a>
                    <a href="javascript:;" @click="cancel" v-if="operation === 'cancel'">
                        <Icon type="close"/>
                    </a>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    export default {
        data () {
            return {}
        },
        props: {
            goods: Object,
            operation: {
                type: String,
                default: 'cancel'
            },
            editabled: {
                type: Boolean,
                default: false
            },
            num: {
                type: Number,
                default: 1
            },
            index: {
                type: Number,
                default: 0
            }
        },
        computed: {
            getNum () {
                return this.num
            }
        },
        methods: {
            cancel () {
                this.$emit('cancel', this.goods.id)
            },
            minus () {
                this.$emit('min', this.index)
            },
            plus () {
                this.$emit('max', this.index)
            }
        }
    }
</script>
<style lang="scss">
    .order-groups {
        .order-header {
            display: flex;
            flex-wrap: nowrap;
            margin: 10px 0;
            span {
                flex: 1;
                font-size: 14px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 20px;
            }
        }

    }

    .order-list {
        .order-row-header {
            font-size: 16px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 24px;
        }
        .order-row {
            background: #F9FCFF;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            margin-bottom: 20px;
            & > div {
                flex: 1;
            }
            .goods-header {
                width: 140px;
                padding: 20px;
                img {
                    width: 100%;
                }
            }
            .goods-desc {
                h3 {
                    font-size: 16px;
                    color: #5E6D82;
                    letter-spacing: 0;
                    line-height: 24px;
                }
                p {
                    font-size: 16px;
                    color: #5E6D82;
                    letter-spacing: 0;
                    line-height: 20px;
                }
            }
            .goods-price, .goods-num {
                font-size: 24px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 26px
            }
            .goods-num .goods-num-editable {
                display: flex;
                align-items: center;
                .number {
                    min-width: 20px;
                    display: inline-block;
                    text-align: center;
                    margin: 0 5px;
                }
                button {
                    border: none;
                    padding: 3px 15px;
                    color: #fff;
                    i {
                        vertical-align: middle;
                    }
                }
                .minus {
                    border-bottom-left-radius: 5px;
                    border-top-left-radius: 5px;
                    background: #D3DCE6;
                    &:active {
                        background: darken(#D3DCE6, 10%)
                    }
                }
                .plus {
                    border-bottom-right-radius: 5px;
                    border-top-right-radius: 5px;
                    background-color: #0084FF;
                    &:active {
                        background: darken(#0084FF, 10%)
                    }
                }
            }
            .text-primary {
                color: #0084FF;
            }
            .goods-operation {
                font-size: 16px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 24px;
            }
        }
        .goods-checkbox {
            display: flex;
            margin-left: 8px;
            align-items: center;
        }
    }

</style>




// WEBPACK FOOTER //
// OrderList.vue?bbf849c8